import React, { useRef } from 'react'
import Box from '@mui/material/Box'
import Application from './Application'
import { useApplicationSuiteContext } from '../contexts/ApplicationSuiteProvider'
import PatternBuilderApp from '../app/builder/app/PatternBuilderApp'
import ShowcaseApp from '../app/showcase/app/ShowcaseApp'
import './MainLayout.css'
import SideNavigation from './SideNavigation'
import { useTheme } from '@mui/material/styles'
import AlertApp from '../app/alerts/app/AlertApp'
import ProfileApp from '../app/profile/app/ProfileApp'
import SessionsApp from '../app/sessions/app/SessionsApp'
import StrategyTutorial, { StrategyTutorialRef } from '../components/tour/StrategyTutorial'

export enum Tabs {
  PatternBuilder = 0,
  BacktestReport = 2,
  Training = 3,
  Showcase = 4,
  BacktestEdit = 6,
  Alerts = 7,
  Profile = 8,
  AgentSessions = 9,
}

function MainLayout() {
  const theme = useTheme()
  const tutorialRef = useRef<StrategyTutorialRef>(null)

  const { activeTab } = useApplicationSuiteContext()

  const tabComponents = {
    [Tabs.PatternBuilder]: <PatternBuilderApp tab={Tabs.PatternBuilder} />,
    // [Tabs.BacktestReport]: <BacktestReportApp tab={Tabs.BacktestReport} />,
    // [Tabs.Training]: <TrainingApp tab={Tabs.Training} />,
    [Tabs.Showcase]: <ShowcaseApp tab={Tabs.Showcase} />,
    // [Tabs.BacktestEdit]: <BacktestEdit/>,
    [Tabs.Alerts]: <AlertApp tab={Tabs.Alerts} />,
    [Tabs.Profile]: <ProfileApp tab={Tabs.Profile} />,
    [Tabs.AgentSessions]: <SessionsApp />,
  }

  const handleTutorialComplete = () => {
    console.log('Tutorial completed')
    // You could save a flag in localStorage here to remember the tutorial has been completed
  }

  // Determine the current pageContext based on activeTab
  const getTutorialContext = () => {
    switch (activeTab.tab) {
      case Tabs.PatternBuilder:
        return 'patternBuilder'
      case Tabs.BacktestReport:
      case Tabs.BacktestEdit:
      case Tabs.Showcase: // Map Showcase tab to backtest context
        return 'backtest'
      case Tabs.Alerts:
        return 'alerts'
      default:
        return 'patternBuilder' // Default to patternBuilder for other tabs
    }
  }

  return (
    <>
      <StrategyTutorial
        ref={tutorialRef}
        onComplete={handleTutorialComplete}
        pageContext={getTutorialContext()}
      />

      <Box className="mainLayout" sx={{ backgroundColor: theme.palette.background.custom1 }}>
        <SideNavigation tutorialRef={tutorialRef} />

        <Box sx={{ width: '100%', height: '100%' }} pl={1}>
          {Object.entries(tabComponents).map(([tabIndex, component]) => (
            <Box
              key={tabIndex}
              className={activeTab.tab === parseInt(tabIndex) ? 'activeTab' : 'inactiveTab'}
            >
              {component}
            </Box>
          ))}
          {/* Fallback for any other tab */}
          {!(activeTab.tab in tabComponents) && (
            <Box className="activeTab">
              <Application AppComponent={Box} />
            </Box>
          )}
        </Box>
      </Box>
    </>
  )
}

export default MainLayout
